export const CATEGORY_LABELS: Record<string, string> = {
  hormones: 'Hormones',
  metabolic: 'Metabolic Panel',
  lipids: 'Lipids',
  vitamins: 'Vitamins & Minerals',
  inflammation: 'Inflammation',
  blood_cells: 'Blood Cells',
  thyroid: 'Thyroid',
  liver: 'Liver',
  kidney: 'Kidney',
};

export const CATEGORY_ORDER = [
  'hormones',
  'metabolic',
  'lipids',
  'vitamins',
  'inflammation',
  'blood_cells',
  'thyroid',
  'liver',
  'kidney',
];

export const CATEGORY_COLORS: Record<string, string> = {
  hormones: '#c47d2e',
  metabolic: '#3d5a80',
  lipids: '#2a9d8f',
  vitamins: '#e76f51',
  inflammation: '#e63946',
  blood_cells: '#457b9d',
  thyroid: '#6a4c93',
  liver: '#1d3557',
  kidney: '#264653',
};

export function statusColor(status: string): string {
  if (status.startsWith('critical')) return '#ef4444';
  if (status.includes('below') || status.includes('above')) return '#f59e0b';
  return '#22c55e';
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'critical_low':
      return 'Critical Low';
    case 'critical_high':
      return 'Critical High';
    case 'below_optimal':
      return 'Below Optimal';
    case 'above_optimal':
      return 'Above Optimal';
    default:
      return 'Optimal';
  }
}
